<link rel="ractive" href="../../r-docs.html">
<link rel="ractive" href="../../components/header.html" name="c-header">
<link rel="ractive" href="../../components/footer.html" name="c-footer">
<link rel="ractive" href="../../components/notification.html" name="c-notification">
<link rel="ractive" href="../../components/header-gradient.html" name="c-header-gradient">

<r-docs noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<style>
		{{#unless loaded}}
			[slot] {
				display: none;
			}
		{{/unless}}
	</style>

	<c-notification></c-notification>
	<c-header useWhiteLogos="true" additionalClasses="header-with-dark-bg header-fw-docs"></c-header>

	{{#if screenWidth}}
		<rapi-doc
			spec-url="{{@shared.apiDocsHost}}/v1/spec.yaml"
			id="thedoc"
			theme="light"
			load-fonts="false"
			render-style="{{readStyle}}"
			regular-font="Lexend, sans-serif"
			mono-font="'Source Code Pro', monospace"
			show-header="false"
			allow-search="true"
			allow-advanced-search="false"
			allow-spec-url-load="false"
			allow-spec-file-load="false"
			allow-spec-file-download="true"
			allow-server-selection="false"
			allow-authentication="false"
			schema-description-expanded="true"
			match-type="includes"
			allow-schema-description-expand-toggle="false"
		>
		</rapi-doc>
	{{/if}}
</r-docs>

<script>
	const listeners = require('../../../assets/js/utils/listeners');

	component.exports = {
		data () {
			return {
				title: 'jsDelivr API',
			};
		},
		computed: {
			readStyle () {
				return this.get('screenWidth') < 768 ? 'view' : 'read';
			},
		},
		onrender () {
			if (!Ractive.isServer) {
				this.set('screenWidth', innerWidth);

				listeners.screenWidthListener(this);

				this.find('rapi-doc').addEventListener('before-render', () => {
					this.set('loaded', true);
				});
			}
		},
};
</script>
